import { ChevronRightIcon, ChevronLeftIcon } from '@ag1/ui';
import { SliderBtnControlsProps } from './SliderProduct.types';

const SliderBtnControls = ({
  className,
  direction,
  onClick,
  disabled,
  ariaLabel
}: SliderBtnControlsProps) => (
  <button
    type="button"
    aria-label={ariaLabel}
    onClick={onClick}
    disabled={disabled}
    className={className}>
    <span>
      {direction === 'left' && <ChevronLeftIcon size={32} />}
      {direction === 'right' && <ChevronRightIcon size={32} />}
    </span>
  </button>
);

export default SliderBtnControls;
